import React from "react";
import {PdfElementProps} from "./_models";
import {
    Text,
    StyleSheet,
} from "@react-pdf/renderer";

export function PdfAlternativeComponent({config}: PdfElementProps) {
    const style = StyleSheet.create({
        main: {
            ...{
                fontSize: '15pt',
                fontWeight: 'bold',
                color: '#666666'
            },
            ...(config.style || {}),
        }
    })

    return (
        <Text style={style.main}>{config.content}</Text>
    )
}